import axios from '@fs/zion-axios'
import type { PersonId } from '@fs/zion-tree-types'
import { mutateFocusPerson } from './useFocusPerson'

type Props = {
  personId: PersonId
  unpublished: boolean
}

/**
 * Hides a person from the public (`unpublished: true`) or restores them (`false`). Mostly used for
 * people in a public researcher tree (User Trees, previously known as CETs); the backend enforces
 * who may call it and answers 403 when the caller may not. The service accepts an optional
 * `reason`, which product chose not to collect.
 */
export default async function setPersonPublishState({ personId, unpublished }: Props): Promise<void> {
  // Only revalidate once the write actually succeeded, so a rejection leaves the cached person alone.
  await axios.put(`/service/tree/tree-data/person/${personId}/publish`, { unpublished })
  await mutateFocusPerson(personId)
}
